import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  
  { name: 'Ponni Rice', image: '/images/rice/ponni.webp', link: '/rice/ponni' },
  { name: 'Idli Rice', image: '/images/rice/idli.webp', link: '/rice/idli' },
  { name: 'Sona Masoori Rice', image: '/images/rice/sonamasoori.webp', link: '/rice/sonamasoori' },
  { name: 'Jeeraga Samba Rice', image: '/images/rice/jeera.webp', link: '/rice/jeerasamba' },
  { name: 'Red Matta Rice', image: '/images/rice/matta.webp', link: '/rice/redmatta' },
  { name: 'Vadi Matta Rice', image: '/images/rice/vadimatta.webp', link: '/rice/vadimatta' },
  { name: 'Karuppu Kavuni Rice', image: '/images/rice/kavuni.webp', link: '/rice/karuppukavuni' },
  { name: 'Mapla Samba Rice', image: '/images/rice/mapla.webp', link: '/rice/maplasamba' },
  { name: 'Kullakar', image: '/images/rice/Kullakar.png', link: '/rice/kullakar' },
  { name: 'Thooyamalli Rice', image: '/images/rice/thooyamalli.webp', link: '/rice/thooyamalli' },
  { name: 'Kaatuyanam', image: '/images/rice/kaatuyanam.webp', link: '/rice/kaatuyanam' },
  { name: '60tham Kuruvai', image: '/images/rice/kuruvai.webp', link: '/rice/kuruvai60' },
  { name: 'Karungkuruvai', image: '/images/rice/karungkuruvai.webp', link: '/rice/karungkuruval' },
  { name: 'Surti Kolam', image: '/images/rice/surti.webp', link: '/rice/surtikolam' },

];

const qtyOptions = ['200g', '500g', '1kg', '5kg', '10kg','20kg', '25kg', '50kg'];

const Rice = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const toggleQtyType = (productIndex, qtyType) => {
    const productQuantities = selectedQuantities[productIndex] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [productIndex]: updated,
    });
  };

  const incrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...productQuantities,
        [qtyType]: currentQty + 1,
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...productQuantities,
          [qtyType]: currentQty - 1,
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const quantities = selectedQuantities[index];
    if (!quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Rice Products</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>

            <div className="qty-options">
              {qtyOptions.map((qtyType) => {
                const isSelected = selectedQuantities[index]?.[qtyType];

                return (
                  <div key={qtyType} className="qty-select-block">
                    <span
                      className={isSelected ? 'qty selected' : 'qty'}
                      onClick={() => toggleQtyType(index, qtyType)}
                    >
                      {qtyType}
                    </span>
                    {isSelected && (
                      <div className="qty-controls">
                        <button onClick={() => decrementQty(index, qtyType)}>-</button>
                        <span>{selectedQuantities[index][qtyType]}</span>
                        <button onClick={() => incrementQty(index, qtyType)}>+</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Rice;
